<template>
    <span v-if="item.result[configuration.field]">{{ item.result[configuration.field].volumeAsString }}</span>
</template>

<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { Options, Vue } from 'vue-class-component';
import { Resource } from '@/helpers/Interfaces';

import { DynamicGridColumn } from '../../services/DynamicGridService';

@Options({})
export default class WeightFormatter extends Vue
{
    @Prop()
    public configuration: DynamicGridColumn;
    @Prop()
    public item: Resource<any>;
}
</script>
